import styled from 'styled-components'

export const Container = styled.span`
  width: auto;
  counter-reset: chapter;
  counter-increment: chapter;
  transition: all 1s;
`
